// extracted by mini-css-extract-plugin
export default {"menu":"BlockchainMenu_menu__20qi7"};